import { Injectable } from '@angular/core';
import * as moment from 'moment';

@Injectable({ providedIn: 'root' })
export class DateService {
    formatDate(field: any) {
        if (field == null) {
            return null;
        }

        return moment(field).format('YYYY-MM-DD');
    }

    getDate(dateStr: string) {
        if (typeof dateStr === 'string') {
            return new Date(dateStr);
        }

        return dateStr;
    }

    getMonth(dateStr: string) {
        if (typeof dateStr === 'string') {
            return new Date(dateStr).getMonth() + 1;
        }

        return dateStr;
    }

    formatTimeForDb(field: any) {
        if (field == null) {
            return null;
        }

        return moment(field).format('HH:mm:ss');
    }

    getCurrentDate() {
        return new Date();
    }

    getFirstDayOfYear(format = 'YYYY-MM-DD'): string {
        return moment()
            .startOf('year')
            .format(format ?? 'YYYY-MM-DD');
    }

    getFirstDayOfMonth(format = 'YYYY-MM-DD'): string {
        return moment()
            .startOf('month')
            .format(format ?? 'YYYY-MM-DD');
    }

    getLastDayOfMonth(format = 'YYYY-MM-DD'): string {
        return moment()
            .endOf('month')
            .format(format ?? 'YYYY-MM-DD');
    }
}
